.globalLoadingWrapper {
    width: 100%;
    height: 100vh;
}
